import formatMoney from '../formatMoney';

const updateFormControls = ({
  variant,
  qty,
  variantsData,
  optionNames,
  selectedOptions,
  atcButton,
  atcButtonPrice,
  atcButtonPipe,
  quantitySelector
}) => {
  if (!atcButton || !quantitySelector) return;

  const allOptionsSelected = variantsData.length === 1 || optionNames.every(name => selectedOptions[name]);
  const quantityControls = quantitySelector.querySelectorAll('button, input');

  if (variant && variant.available && allOptionsSelected) {
    const price = variant.price;
    quantitySelector.dataset.qtySelectorVariantPrice = price;
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    atcButton.disabled = false;
    if (atcButtonPrice) atcButtonPrice.textContent = formatMoney(price * qty);
    atcButtonPipe?.classList.remove('hidden');
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
    if (atcButtonPrice) atcButtonPrice.textContent = '';
    atcButtonPipe?.classList.add('hidden');
  }
};

export default updateFormControls;
